import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneMusic } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import {
  FiImage,
  FiMusic,
  FiCalendar,
  FiDollarSign,
} from "react-icons/fi";

const dayOptions = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
  "annual",
];

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const music: any = getOneMusic();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);
  const music_id = music?.music_id;
  const [thumbnail, setThumbnail] = useState<any>(music?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(music?.image_cdn_id);
  const [title, setTitle] = useState<any>(music?.title);
  const [hashtags, setHashtags] = useState<any>(music?.hashtag);
  const [eventStatus, setEventStatus] = useState<any>(music?.status);
  const [description, setDescription] = useState<any>(music?.description);
  const [repeatEvery, setRepeatEvery] = useState<any>(music?.repeat_every);
  const [expo, setExpo] = useState<any>(music?.expo);
  const [pricing, setPricing] = useState<any>(music?.Pricings);
  const [venue, setVenue] = useState<any>(music?.venue);
  const [startDate, setStartDate] = useState<any>(music?.start_date);
  const [endDate, setEndDate] = useState<any>(music?.end_date);
  const [startTime, setStartTime] = useState<any>(music?.start_time);
  const [endTime, setEndTime] = useState<any>(music?.end_time);
  const [venueCapacity, setVenueCapacity] = useState<any>(music?.venue_capacity);
  const [email, setEmail] = useState<any>(music?.email_address);
  const [payLink, setPayLink] = useState<any>(music?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(music?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(music?.whatsapp);
  const [facebook, setFacebook] = useState<any>(music?.facebook);
  const [twitter, setTwitter] = useState<any>(music?.twitter);
  const [instagram, setInstagram] = useState<any>(music?.instagram);
  const [youtube, setYoutube] = useState<any>(music?.youtube);
  const [googleMapCode, setGoogleMapCode] = useState<any>(music?.google_map_code);
  const [latitude, setLatitude] = useState<any>(music?.latitude);
  const [longitude, setLongitude] = useState<any>(music?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    music?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(music?.featured);
  const [promoted, setPromoted] = useState<any>(
    music?.promoted ? music?.promoted : "no"
  );
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const musicRoutes = "/data/music";

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneMusicHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : music?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      hashtag: hashtags,
      status: eventStatus,
      repeat_every: repeatEvery,
      expo: expo,
      pricing: pricing,
      venue: venue,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      venue_capacity: venueCapacity,
      end_time: endTime,
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      featured: featured,
      promoted: promoted,
    };

    const { message, status } = await updateOneContent({
      data_id: music_id,
      data: data,
      content: _TYPES_.MUSIC,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  const toggleRepeat = (val: string) => {
    const parts = (repeatEvery || "")
      .toString()
      .split("|")
      .filter(Boolean);
    if (parts.includes(val)) {
      setRepeatEvery(parts.filter((d: string) => d !== val).join("|"));
    } else {
      setRepeatEvery([...parts, val].join("|"));
    }
  };

  return (
    <AddPageShell
      backRoute={musicRoutes}
      eyebrow="DoSee Data • Music"
      title="Edit Music"
      subtitle={`Update a concert, set or release in ${entry_label || "this destination"}.`}
      icon={<FiMusic className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneMusicHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Lead artwork or photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.MUSIC)}
        />
      </AddSection>

      <AddSection title="Concert Details" hint="Title, venue and capacity.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              required: true,
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Optional schedule and recurring days."
        icon={<FiCalendar className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
        <div className="mt-5">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            Repeat Every
          </p>
          <div className="flex flex-wrap gap-3">
            {dayOptions.map((val) => {
              const selected = (repeatEvery || "")
                .toString()
                .split("|")
                .includes(val);
              return (
                <button
                  key={val}
                  type="button"
                  onClick={() => toggleRepeat(val)}
                  className={[
                    "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium capitalize transition",
                    selected
                      ? "border-brand bg-brand/10 text-brand"
                      : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50",
                  ].join(" ")}
                >
                  {selected ? (
                    <MdCheckBox className="h-4 w-4" />
                  ) : (
                    <MdCheckBoxOutlineBlank className="h-4 w-4" />
                  )}
                  {val}
                </button>
              );
            })}
          </div>
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Tickets and tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="music_status"
        setStatus={setEventStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={eventStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
